import validator from 'validator';
import { ValidationStrings } from './../../dataProvider/localize'
import { customPhonoeNoValidate } from './../common'

export const isServiceRequired = value => value ? undefined : "Select Service"
export const isCategoryRequired = value => value ? undefined : "Select Category"
export const isSubCategoryRequired = value => value ? undefined : "Select Sub-Category"

export const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = ValidationStrings.organization_validation_name
  }
  if (!values.primary_person) {
    errors.primary_person = ValidationStrings.organization_validation_primary_person
  }

  if (!values.phone_number) {
    errors.phone_number = ValidationStrings.organization_validation_phone_number
  } else if (!validator.isMobilePhone(values.phone_number, 'any')) {
    if (customPhonoeNoValidate(values.phone_number) === true) {
      console.log('allow ph no')
    } else {
      errors.phone_number = ValidationStrings.organization_validation_invalid_phone_number
    }
  }

  if (!values.email_address) {
    errors.email_address = ValidationStrings.organization_validation_email_address
  } else if (!validator.isEmail(values.email_address)) {
    errors.email_address = ValidationStrings.organization_validation_invalid_email_address
  }

  if (Array.isArray(values.subscription_id) && values.subscription_id.length === 0) {
    errors.subscription_id = ValidationStrings.organization_validation_subscription_id
  }

  if (!values.subscription_id) {
    errors.subscription_id = ValidationStrings.organization_validation_subscription_id;
  }
  if (!values.abn_acn) {
    errors.abn_acn = ValidationStrings.organization_validation_abn_acn;
  }
  if (values.abn_acn) {
    if (!/^(?=[0-9]*$)(?:.{9}|.{11})$/.test(values.abn_acn.replace(/\s/g, ""))) {
      errors.abn_acn = ValidationStrings.organization_validation_invalid_abn_acn
    }
  }
  if (!values.org_users || !values.org_users.length > 0 || !Array.isArray(values.org_users)) {

  } else {
    const org_users_errors = [];
    values.org_users.forEach((user, index) => {
      const userErrors = {}

      if (!user.name) {
        userErrors.name = ValidationStrings.organization_validation_user_name;
      }

      if (Array.isArray(user.role_id) && user.role_id.length === 0) {
        userErrors.role_id = ValidationStrings.org_user_role_empty;
      }

      if (!user.role_id) {
        userErrors.role_id = ValidationStrings.organization_validation_role_id;
      }

      if (!user.email_address) {
        userErrors.email_address = ValidationStrings.organization_validation_user_email_address;
      } else if (!validator.isEmail(user.email_address)) {
        userErrors.email_address = ValidationStrings.organization_validation_invalid_email_address;
      }

      if (!user.phone_number) {
        userErrors.phone_number = ValidationStrings.organization_validation_user_phone_number;
      } else if (!validator.isMobilePhone(user.country_code + user.phone_number, 'any')) {
        userErrors.phone_number = ValidationStrings.organization_validation_invalid_phone_number
      }

      org_users_errors[index] = userErrors;
    })
    errors.org_users = org_users_errors;
    console.log(org_users_errors)
  }

  if (!values.address) {
    errors.address = ValidationStrings.profile_street_address_empty
  }

  return errors
}
